import {Link, matchPath, useLocation} from "react-router-dom";
import {AppRoles, AppRoutes} from "../../utils/constants";
import {useAuthService} from "../../services/auth-service";
import NavbarProfile from "./navbar-profile";
import {useRef, useState} from "react";
import detectOutsideClickHook from "../../utils/detectOutsideClick.hook";

function NavbarMenu(props) {

  const { pathname } = useLocation();
  const { can, hasRole } = useAuthService();

  const [adminCollapsed, setAdminCollapsed] = useState(true);

  const adminMenu = useRef(null);
  detectOutsideClickHook(adminMenu, ()=>{setAdminCollapsed(true)});

  return (
    <>
      <ul className="navbar-nav">
        <li className={`nav-item dropdown ${matchPath(AppRoutes.home.path, pathname) ? 'active' : ''}`}>
          <Link to={AppRoutes.home.path} className={`nav-link dropdown-toggle arrow-none`} role="button">
            <i className="uil-apps me-1"></i> Domov
          </Link>
        </li>

        <li className={`nav-item dropdown ${matchPath(AppRoutes.membership.path, pathname) ? 'active' : ''}`}>
          <Link to={AppRoutes.membership.path} className={`nav-link dropdown-toggle arrow-none`} role="button">
            <i className="uil-archway me-1"></i> Družstvo
          </Link>
        </li>

        <li className={`nav-item dropdown ${matchPath(AppRoutes.buildingsPortfolio.path, pathname) ? 'active' : ''}`}>
          <Link to={AppRoutes.buildingsPortfolio.path} className={`nav-link dropdown-toggle arrow-none`} role="button">
            <i className="uil-building me-1"></i> Portfólio nehnuteľností
          </Link>
        </li>

        {/*<li className="nav-item dropdown">*/}
        {/*  <a className="nav-link dropdown-toggle arrow-none"*/}
        {/*     href="https://coderthemes.com/hyper_2/saas/layouts-horizontal.html#" id="topnav-pages"*/}
        {/*     role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">*/}
        {/*    <i className="uil-users-alt me-1"></i>Spoluvlastníctvo*/}
        {/*  </a>*/}
        {/*</li>*/}

        {/*<li className="nav-item dropdown">*/}
        {/*  <a className="nav-link dropdown-toggle arrow-none"*/}
        {/*     href="https://coderthemes.com/hyper_2/saas/layouts-horizontal.html#" id="topnav-components"*/}
        {/*     role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">*/}
        {/*    <i className="uil-building me-1"></i>Portfólio nehnuteľností <div className="arrow-down"></div>*/}
        {/*  </a>*/}
        {/*  <div className="dropdown-menu" aria-labelledby="topnav-components">*/}
        {/*    <a href="https://coderthemes.com/hyper_2/saas/widgets.html" className="dropdown-item">Hollého</a>*/}
        {/*    <a href="https://coderthemes.com/hyper_2/saas/widgets.html"*/}
        {/*       className="dropdown-item">Rastislavova</a>*/}
        {/*    <a href="https://coderthemes.com/hyper_2/saas/widgets.html"*/}
        {/*       className="dropdown-item">Štefániková</a>*/}
        {/*    <a href="https://coderthemes.com/hyper_2/saas/widgets.html" className="dropdown-item">Vratkov*/}
        {/*      byt</a>*/}
        {/*  </div>*/}
        {/*</li>*/}

        {/*<li className="nav-item dropdown">*/}
        {/*  <a className="nav-link dropdown-toggle arrow-none"*/}
        {/*     href="https://coderthemes.com/hyper_2/saas/layouts-horizontal.html#" id="topnav-layouts"*/}
        {/*     role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">*/}
        {/*    <i className="uil-coins me-1"></i>Burza*/}
        {/*  </a>*/}
        {/*</li>*/}


      </ul>

      <ul className="navbar-nav list-unstyled my-2 my-md-0" ref={adminMenu}>

        {hasRole([AppRoles.admin, AppRoles.manager]) && <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle arrow-none"
             id="adminMenu"
             role="button"
             aria-haspopup="true"
             aria-expanded={!!adminCollapsed}
             onClick={(event)=>setAdminCollapsed(!adminCollapsed)}>
            <i className="uil-cog me-1"></i>Správa IHRE<div className="arrow-down"></div>
          </a>
          <div className={`dropdown-menu dropdown-menu-animated${adminCollapsed ? '' : ' show' }`} aria-labelledby="adminMenu">
            {can(['manage_users']) && <>
              <Link onClick={()=>{setAdminCollapsed(true)}} to={AppRoutes.users.path} className={`dropdown-item`}>
                <i className="uil-users-alt me-1"></i> Používatelia
              </Link>
              <Link onClick={()=>{setAdminCollapsed(true)}} to={AppRoutes.userGroups.path} className={`dropdown-item`}>
                <i className="uil-layer-group me-1"></i> Používatelské skupiny
              </Link>
              <Link onClick={()=>{setAdminCollapsed(true)}} to={AppRoutes.representatives.path} className={`dropdown-item`}>
                <i className="dripicons-user-group me-1"></i> Delegáti
              </Link>

            </>}

            {can(['manage_permissions']) && <Link onClick={()=>{setAdminCollapsed(true)}} to={AppRoutes.roles.path} className={`dropdown-item`}>
              <i className="uil-key-skeleton me-1"></i> Role
            </Link>}

            {can(['manage_attachment_categories']) && <Link onClick={()=>{setAdminCollapsed(true)}} to={AppRoutes.attachmentCategories.path} className={`dropdown-item`}>
              <i className="uil-tag-alt me-1"></i> Kategórie dokumentov
            </Link>}

            {can(['manage_buildings']) && <>
              <Link onClick={()=>{setAdminCollapsed(true)}} to={AppRoutes.buildings.path} className={`dropdown-item`}>
                <i className="dripicons-home me-1"></i> Budovy
              </Link>
              <Link onClick={()=>{setAdminCollapsed(true)}} to={AppRoutes.managers.path} className={`dropdown-item`}>
                <i className="dripicons-lightbulb me-1"></i> Správcovia
              </Link>
              <Link onClick={()=>{setAdminCollapsed(true)}} to={AppRoutes.buildingStats.path} className={`dropdown-item`}>
                <i className="dripicons-graph-pie me-1"></i> Údaje budovy
              </Link>
              <Link onClick={()=>{setAdminCollapsed(true)}} to={AppRoutes.buildingStatTypes.path} className={`dropdown-item`}>
                <i className="uil-tag-alt me-1"></i> Typy údajov budovy
              </Link>
            </>}

            {can(['manage_internal_values']) && <Link onClick={()=>{setAdminCollapsed(true)}} to={AppRoutes.internalValues.path} className={`dropdown-item`}>
              <i className="uil-anchor me-1"></i> Interná hodnota
            </Link>}

            {can(['manage_internal_values']) && <Link onClick={()=>{setAdminCollapsed(true)}} to={AppRoutes.membershipShares.path} className={`dropdown-item`}>
              <i className="uil-abacus me-1"></i> Členské podiely
            </Link>}

            {can(['manage_transactions']) && <Link onClick={()=>{setAdminCollapsed(true)}} to={AppRoutes.transactions.path} className={`dropdown-item`}>
              <i className="uil-sorting me-1"></i> Transakcie
            </Link>}

            {can(['manage_articles']) && <Link onClick={()=>{setAdminCollapsed(true)}} to={AppRoutes.articles.path} className={`dropdown-item`}>
              <i className="uil-newspaper me-1"></i> Články
            </Link>}

            {can(['manage_attachments']) && <Link onClick={()=>{setAdminCollapsed(true)}} to={AppRoutes.membershipDocuments.path} className={`dropdown-item`}>
              <i className="uil-document me-1"></i> Dokumenty družstva
            </Link>}
            {can(['manage_attachments']) && <Link onClick={()=>{setAdminCollapsed(true)}} to={AppRoutes.membershipGallery.path} className={`dropdown-item`}>
              <i className="uil-image me-1"></i> Galéria družstva
            </Link>}

          </div>
        </li>}

        {/*<li className="dropdown notification-list topbar-dropdown d-none d-lg-block">*/}
        {/*  <NavbarLanguages />*/}
        {/*</li>*/}
        {/*<li className="dropdown notification-list">*/}
        {/* <NavbarNotifications />*/}
        {/*</li>*/}
        <li className="notification-list bg-dark">
          <NavbarProfile />
        </li>
      </ul>

    </>
  );
}

export default NavbarMenu
